export default __webpack_public_path__ + "static/egp2-18c93230ee1f2609736cf38d55807381.jpg";